import React from 'react';

const OfficeHours = () => {
  const hours = [
    { day: 'Monday', hours: '8:00am - 5:00pm' },
    { day: 'Tuesday', hours: '8:00am - 5:00pm' },
    { day: 'Wednesday', hours: '8:00am - 5:00pm' },
    { day: 'Thursday', hours: '8:00am - 5:00pm' },
    { day: 'Friday', hours: '8:00am - 5:00pm' },
    { day: 'Saturday', hours: '9:00am - 12:00pm' },
    { day: 'Sunday', hours: 'Closed' },
  ];
  
  // Split the hours array into two rows
  const firstRow = hours.slice(0, 4);
  const secondRow = hours.slice(4);
  
  return (
    <div className="w-full max-w-6xl mx-auto p-4 laptop:p-6 bg-custom-darkBlue rounded-lg">
      <h2 className="text-xl laptop:text-2xl font-bold mb-4 laptop:mb-6 text-center text-white">Hours of Operation</h2>
      
      <div className="space-y-4">
        {/* First row - 4 cards */}
        <div className="grid smartphone:grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-3 laptop:gap-4">
          {firstRow.map(({ day, hours }) => (
            <div
              key={day}
              className="flex flex-col items-center bg-gray-700 bg-opacity-50 rounded-lg shadow-md
                        smartphone:flex-row smartphone:h-20 tablet:flex-col tablet:h-48 laptop:h-60"
            >
              <div className="font-bold text-white text-lg 
                            smartphone:py-2 smartphone:px-4 smartphone:w-1/3 smartphone:text-left smartphone:border-r smartphone:border-b-0
                            tablet:pt-6 tablet:pb-2 tablet:border-b tablet:border-r-0 tablet:w-full tablet:text-center
                            laptop:pt-6 laptop:pb-2 laptop:border-b laptop:w-full laptop:text-center 
                            border-gray-600">
                {day}
              </div>
              <div className="flex-grow flex items-center justify-center px-2 
                            smartphone:w-2/3 smartphone:justify-start 
                            tablet:w-full tablet:justify-center">
                <div className="text-sm laptop:text-base text-gray-300 text-center">{hours}</div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Second row - 3 cards */}
        <div className="grid smartphone:grid-cols-1 tablet:grid-cols-3 laptop:grid-cols-3 gap-3 laptop:gap-4 mx-auto max-w-full laptop:max-w-[75%]">
          {secondRow.map(({ day, hours }) => (
            <div
              key={day}
              className="flex flex-col items-center bg-gray-700 bg-opacity-50 rounded-lg shadow-md
                        smartphone:flex-row smartphone:h-20 tablet:flex-col tablet:h-48 laptop:h-60"
            >
              <div className="font-bold text-white text-lg 
                            smartphone:py-2 smartphone:px-4 smartphone:w-1/3 smartphone:text-left smartphone:border-r smartphone:border-b-0
                            tablet:pt-6 tablet:pb-2 tablet:border-b tablet:border-r-0 tablet:w-full tablet:text-center
                            laptop:pt-6 laptop:pb-2 laptop:border-b laptop:w-full laptop:text-center 
                            border-gray-600">
                {day}
              </div>
              <div className="flex-grow flex items-center justify-center px-2 
                            smartphone:w-2/3 smartphone:justify-start 
                            tablet:w-full tablet:justify-center">
                <div className="text-sm laptop:text-base text-gray-300 text-center">{hours}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfficeHours;